<template>
  <v-col cols="12" class="patientCardContainer">
    <v-card class="patientCard">
      <v-toolbar :flat="true">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ patient.name }}</v-list-item-title>
            <v-list-item-subtitle v-if="patient.id_type"
              >{{ patient.id_type }} : {{ patient.id_nr }}</v-list-item-subtitle
            >
            <v-list-item-subtitle>{{ patient.dob }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <v-card-text>
        <v-simple-table :dense="true" :fixed-header="true">
          <thead>
            <tr>
              <th class="text-left">Datum</th>
              <th class="text-left">Code</th>
              <th class="text-left">Beschrijving</th>
              <th class="text-right">Omzet</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in patient.declaraties"
              :key="index"
              :class="{
                'amber lighten-4': patient.error_days.indexOf(item.date) === 0,
                'amber lighten-3': patient.error_days.indexOf(item.date) >= 1
              }"
            >
              <td>
                <v-icon
                  v-if="patient.error_days.indexOf(item.date) !== -1"
                  small
                  color="warning"
                  class="d-none d-print-inline"
                  >mdi-alert</v-icon
                >
                {{ item.date }}
              </td>
              <td>{{ item.code }}</td>
              <td>{{ item.descr }}</td>
              <td class="text-right">{{ item.bedrag | currency }}</td>
            </tr>
          </tbody>
          <tfoot class="d-print-none">
            <tr class="font-weight-bold">
              <td colspan="3">Totaal</td>
              <td class="text-right">{{ bedragTotaal | currency }}</td>
            </tr>
          </tfoot>
        </v-simple-table>
        <v-alert
          v-for="(msg, index) in patient.dubbel_msg"
          :key="index"
          text
          type="error"
          icon="mdi-alert"
          >{{ msg }}</v-alert
        >
        <v-alert
          v-for="(msg, index) in patient.warn_msg"
          :key="index + '_warn'"
          text
          type="warning"
          icon="mdi-help"
          >{{ msg }}</v-alert
        >
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
export default {
  name: "Patient",
  props: ["patient"],
  data() {
    return {};
  },
  computed: {
    bedragTotaal() {
      let t = 0;
      for (let d of this.patient.declaraties) {
        t += d.bedrag;
      }
      return t;
    }
  }
};
</script>

<style lang="scss">
@media print {
  .patientCard {
    display: inline-block;
    width: 100%;
    page-break-inside: avoid;

    .v-card__text {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .v-alert {
      margin-bottom: 5px;
    }
    .v-data-table--dense td {
      height: 14px;
      font-size: 11px;
    }
  }
  .patientCardContainer {
    padding-bottom: 4px;
    padding-top: 4px;
  }
}
</style>
